import React from 'react';
import { Chip } from '@mui/material';
import { baseChipSx, baseLabelSx } from './chipStyles';

export default function IconTextChip({ icon, label, color = 'default', onClick, sx = {}, disabled = false }) {
  return (
    <Chip
      icon={icon}
      label={label}
      color={color}
      variant="outlined"
      clickable={!!onClick && !disabled}
      disabled={disabled}
      onClick={e => {
        e.stopPropagation();
        if (onClick && !disabled) onClick(e);
      }}
      sx={{
        ...baseChipSx,
        '& .MuiChip-label': {
          ...baseLabelSx,
          paddingRight: '3px',
        },
        '& .MuiChip-icon': { fontSize: '1rem', marginBottom: 0 },
        ...sx,
      }}
    />
  );
}
